<template>
  <div id="app">
    <AppHeader :language="language" @clickLanguage="headerClickLanguage"></AppHeader>
    <AppBaner :language="language"></AppBaner>
    <AppOffers :language="language"></AppOffers>
    <AppDistribution :language="language"></AppDistribution>
    <AppInfo :language="language"></AppInfo>
    <AppPartners :language="language"></AppPartners>
    <AppFooter :language="language"></AppFooter>
  </div>
</template>

<script>
  import AppHeader from './views/Header.vue'
  import AppBaner from './views/Baner.vue'
  import AppOffers from './views/Offers.vue'
  import AppDistribution from './views/Distribution.vue'
  import AppInfo from './views/Info.vue'
  import AppPartners from './views/Partners.vue'
  import AppFooter from './views/Footer.vue'

  export default {
    name: "app",
    components: {AppHeader, AppBaner, AppOffers, AppDistribution, AppInfo, AppPartners, AppFooter},
    data() {
      return {
        language: 'ru'
      };
    },
    methods: {
      headerClickLanguage(lang){
        this.language = lang
      }
    }
  };
</script>

<style lang="scss">
@media (min-width: 576px) and (max-width: 767px) {
  .H2{font-size: 32px!important;}
}
@media (max-width: 575px) {
  .H2{font-size: 32px!important;}
}
  body {font-family: "Open Sans", sans-serif;background: #f8f8f8;margin: 0;height: 100%;z-index: 1000;color: #696E74;}
  .H2{padding: 0;margin: 0 0 20px 0;font-size: 38px;font-weight: 500;text-align: center;text-transform: uppercase;font-family: 'Open Sans Condensed', sans-serif;color: #252525}
</style>



// WEBPACK FOOTER //
// src/App.vue